import React from 'react'
import ReactDOM from 'react-dom'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'

import App from './App'
import reportWebVitals from './reportWebVitals'
import { CssBaseline } from '@material-ui/core'
import { BrowserRouter as Router } from 'react-router-dom'
import { Provider } from 'react-redux'
import { createStore } from './redux/store'
import ToastAlert from './components/common/ToastAlert'
import DialogAlert from './components/common/DialogAlert'

/**
 * https://v4.mui.com/components/drawers/ left side bar
 * https://v4.mui.com/components/snackbars/ -> UI 변경 시
 * https://v4.mui.com/components/tooltips/#arrow-tooltips -> 처음 진입 시 설명
 * https://v4.mui.com/components/dialogs/#form-dialogs -> 수정\
 * https://v4.mui.com/components/progress/#interactive-integration
 * https://v4.mui.com/components/rating/ -> steps sub tasks
 * https://v4.mui.com/components/menus/#context-menu -> right click
 */

Sentry.init({
  dsn: 'https://91d2abbee9bd4680bf0a4e8b95c04c8d@o1060128.ingest.sentry.io/6049381',
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
})
ReactDOM.render(
  <Provider store={createStore()}>
    <React.StrictMode>
      <CssBaseline />
      <Router>
        <App />
        <ToastAlert />
        <DialogAlert />
      </Router>
    </React.StrictMode>
  </Provider>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
